import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Tooltip } from 'primereact/tooltip';

function MenuItemTooltip(params) {
  const {
    id,
    tooltip,
    position,
    wrapperClassName
  } = params;
  const {
    label,
    icon,
    disabled,
    command
  } = params.item;
  const className = clsx('flex gap-2 align-items-center p-menuitem-content', wrapperClassName);
  const linkClassName = clsx('p-menuitem-link w-full', {
    'p-disabled': disabled
  });
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      target: "#".concat(id)
    }), jsx("div", {
      id: id,
      "data-pr-tooltip": tooltip,
      "data-pr-position": position,
      className: className,
      onClick: event => {
        if (!disabled && command) {
          command({
            originalEvent: event,
            item: params.item
          });
        }
      },
      children: jsxs("div", {
        className: linkClassName,
        children: [icon, label]
      })
    })]
  });
}

export { MenuItemTooltip };
